/*
 * @Author: Chris 
 * @Date: 2022-10-28 10:41:14 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-11-10 13:37:15
 * @msg 进度条，页面顶部一个页面跳转的进度条
 */

import router from "./index";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
// 引入公共模块
import {getParams} from "../plugins/constantFunction";

router.beforeEach((to, from, next) => {
  NProgress.start();

  const url = window.location.search;
  const urlParams = getParams(url);

  // 从太行启翼菜单，固定qiyip1存放token
  console.log('url的参数', urlParams)
  if (urlParams && urlParams.qiyip1) {
    console.log("从太行启翼菜单，固定qiyip1存放token")
    window.localStorage.setItem("UM_accessToken", urlParams.qiyip1);
  }

  if (window.localStorage.getItem("UM_accessToken")) {
    if (to.path === "/login" || to.path === "/") {
      next({
        path: "/organization",
      });
      NProgress.done();
    } else {
      if (window.localStorage.getItem("UM_USER_IDENTITY")) {
        const USER_IDENTITY = JSON.parse(window.localStorage.getItem("UM_USER_IDENTITY"));
        // 判断该路由是否在权限内 即是否可以跳转
        if (to.meta.roles) {
          if (USER_IDENTITY.length) { 
            // 判断权限是否存在交集
            let a = new Set(USER_IDENTITY);
            let b = new Set(to.meta.roles);
            let intersectionSet = new Set([...a].filter((x) => b.has(x)));
            let sameData = Array.from(intersectionSet) || [];
            if (sameData.length) {
              // 有交集 有权限
              next();
            } else {
              // 无交集 无权限
              next({
                path: "/error",
              });
            }
          }
        } else {
          next();
        }

      } else {
        next();
      }
    }
  } else {
    next();
  }

});

router.afterEach(() => {
  NProgress.done();
});